module.exports = __webpack_public_path__ + "img/jewelryEncycTopImg.00d1db3f.svg";